module.exports = __webpack_public_path__ + "img/no-image1.99e20316.png";